import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import { formatByteToMB } from '@/lib/formatter';
import { formatToDate } from '@/utils/datetime';
import { getFullName } from '@/utils/string';
import SelectedTagsAutocomplete from '@/views/dashboard/SelectedTagsAutocomplete.vue';
import { FileWithTag } from './SdsUploadPage.vue';
import { Tag } from '@/interfaces/model/general/tag';
import TagChip from '@/components/TagChip.vue';
import { defineMessages } from '@/lib/i18n';
import sharedMessages from '@/lib/shared-messages';
import {
  DuplicatedSdsAssignee,
  DuplicatedSdsExisting,
  DuplicatedSdsInSameUpload,
  DuplicatedSdsItem,
} from '@/interfaces/api/general/company';


export default /*#__PURE__*/_defineComponent({
  __name: 'UploadFileTable',
  props: {
    files: null,
    sdsUuids: null,
    isAllChecked: { type: Boolean },
    tags: null,
    duplicates: null,
    duplicateChecked: { type: Boolean },
    isUploading: { type: Boolean },
    isCheckingDuplicates: { type: Boolean }
  },
  emits: ["showPdf", "updateTags", "removeTag", "checkedSdsUuids", "removeFile"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'showPdf', file: File, sdsUuid: string): void;
  (e: 'updateTags', tags: Tag[], sdsUuid: string): void;
  (e: 'removeTag', tagId: number, sdsUuid: string): void;
  (e: 'checkedSdsUuids', sdsUuids: string[]): void;
  (e: 'removeFile', index: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  files: FileWithTag[];
  sdsUuids: string[];
  isAllChecked: boolean;
  tags: Tag[];
  duplicates?: DuplicatedSdsItem[];
  duplicateChecked?: boolean;
  isUploading?: boolean;
  isCheckingDuplicates?: boolean;
};

const m = defineMessages({
  fileName: 'ファイル名',
  size: 'サイズ',
  duplicateColumn: '同一SDS有無',
  duplicateAssignees: '担当者',
  duplicateExistingSection: '既存登録SDS',
  duplicatesInSameUploadSection: 'この登録内の重複ファイル',
});





const checkList = ref<boolean[]>([...Array(props.files.length).fill(false)]);

const duplicateMap = computed(() => {
  const map = new Map<string, DuplicatedSdsItem>();
  (props.duplicates ?? []).forEach((d) => map.set(d.sds_uuid, d));
  return map;
});

const getDuplicate = (sdsUuid: string): DuplicatedSdsItem | undefined =>
  duplicateMap.value.get(sdsUuid);

const getExistingSdses = (sdsUuid: string): DuplicatedSdsExisting[] =>
  getDuplicate(sdsUuid)?.existing_sdses ?? [];

const getDuplicatesInSameUpload = (
  sdsUuid: string
): DuplicatedSdsInSameUpload[] =>
  getDuplicate(sdsUuid)?.duplicates_in_same_upload ?? [];

const formatAssignees = (assignees: DuplicatedSdsAssignee[]): string =>
  assignees.map((a) => getFullName({ ...a, departments: [] })).join(', ');

const createSdsDetailUrl = (sdsId: string): string =>
  `${window.location.protocol}//${window.location.host}/#/dashboard/sds/index?uuid=${sdsId}`;

const toggleAllCheck = () => {
  checkList.value = checkList.value.map(() => !checkList.value.every((l) => l));
};

const removeFile = (index: number): void => {
  // checkListはpropsの変更に追従しないため、行削除と同時にここで同期させる
  checkList.value.splice(index, 1);
  emits('removeFile', index);
};

const isIndeterminateCheckBox = computed(
  () => !checkList.value.every((l) => l) && checkList.value.some((l) => l)
);

watch(
  checkList,
  (newValue) => {
    emits(
      'checkedSdsUuids',
      props.sdsUuids.filter((_, i) => newValue[i])
    );
  },
  { deep: true }
);

watch(
  () => props.isAllChecked,
  () => {
    if (props.isAllChecked) {
      checkList.value = checkList.value.map(() => true);
    }
  }
);

return { __sfc: true,m, props, emits, checkList, duplicateMap, getDuplicate, getExistingSdses, getDuplicatesInSameUpload, formatAssignees, createSdsDetailUrl, toggleAllCheck, removeFile, isIndeterminateCheckBox, formatByteToMB, formatToDate, SelectedTagsAutocomplete, TagChip, sharedMessages }
}

})